export default __webpack_public_path__ + "836ab487d1394d5ccc5229b21e334640.jpg";